// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import familyPic from "assets/images/host/family-pic.webp";

// Data
import hostData from "pages/About/sections/data/hostData";

function MeetTheHost() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography variant="h3" mb={4}>
          Meet Your Host
        </MKTypography>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={4}>
            <MKBox
              component="img"
              src={familyPic}
              alt={hostData.name}
              width="200px"
              height="200px"
              borderRadius="50%"
              mx="auto"
              shadow="md"
              sx={{ objectFit: "cover", display: "block" }}
            />
            <MKTypography variant="h5" textAlign="center" mt={2}>
              {hostData.name}
            </MKTypography>
            {hostData.superhost && (
              <MKTypography variant="body2" color="info" textAlign="center" mt={0.5}>
                <Icon sx={{ fontSize: "1rem", verticalAlign: "middle", mr: 0.5 }}>verified</Icon>
                Superhost
              </MKTypography>
            )}
          </Grid>
          <Grid item xs={12} md={8}>
            <MKTypography variant="body1" color="text" mb={3}>
              {hostData.bio}
            </MKTypography>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={3}>
                <MKTypography variant="h4" textAlign="center">
                  {hostData.yearsHosting}+
                </MKTypography>
                <MKTypography variant="body2" color="text" textAlign="center">
                  Years Hosting
                </MKTypography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <MKTypography variant="h4" textAlign="center">
                  {hostData.responseRate}
                </MKTypography>
                <MKTypography variant="body2" color="text" textAlign="center">
                  Response Rate
                </MKTypography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <MKTypography variant="body2" color="text" textAlign="center" fontWeight="bold">
                  {hostData.responseTime}
                </MKTypography>
                <MKTypography variant="body2" color="text" textAlign="center">
                  Response Time
                </MKTypography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <MKTypography variant="body2" color="text" textAlign="center" fontWeight="bold">
                  {hostData.languages.join(", ")}
                </MKTypography>
                <MKTypography variant="body2" color="text" textAlign="center">
                  Languages
                </MKTypography>
              </Grid>
            </Grid>
            <MKBox display="flex" alignItems="center" mt={3}>
              <Icon sx={{ mr: 1 }}>email</Icon>
              <MKTypography
                component="a"
                href="mailto:croceanfrontrentals@gmail.com"
                variant="body2"
                color="info"
                fontWeight="bold"
              >
                croceanfrontrentals@gmail.com
              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default MeetTheHost;
